export const mainColors = {
  guardsmanRed: '#c40000',
};

export const neutralColors = {
  tundora: '#444',
  doveGray: '#6c6c6c',
  boulder: '#777',
  gray: '#888',
  dustyGray: '#9b9b9b',
  silver: '#bbb',
  alto: '#d4d4d4',
  lightGray: '#e2e2e2',
  gallery: '#eaeaea',
  wildSand: '#f3f3f3',
  wildSandLight: '#f8f8f8',
  alabaster: '#fcfcfc',
  white: '#fff',
};

export const supportColorsGreen = {
  limeade: '#5b8601',
  oliveDrab: '#7aa129',
  pineGlade: '#a7cd94',
  peppermint: '#E5F2DD',
};

export const supportColorsRed = {
  totemPole: '#A11205',
  tonysPink: '#E2958B',
  potPourri: '#F7E6E6',
};

export const supportColorsBlue = {
  jellyBean: '#277690',
  aquaIsland: '#ABD5DE',
  catskillWhite: '#E7F3F5',
};

export const supportColorsYellow = {
  pottersClay: '#8A6D3B',
  sandwisp: '#F5E79E',
  pearlLusta: '#FCF8E3',
};

export const supportColorsOther = {
  deepCerulean: '#0073b2',
  goldenTainoi: '#ffc65d',
  black: '#000',
};

export const supportColors = {
  ...supportColorsGreen,
  ...supportColorsRed,
  ...supportColorsBlue,
  ...supportColorsYellow,
  ...supportColorsOther,
};

export const utilityColors = {
  default: '#444',
  positive: '#7aa129',
  caution: '#8a6d3b',
  negative: '#c40000',
  neutral: '#00788f',
};

const colors = {
  ...mainColors,
  ...neutralColors,
  ...supportColors,
};

export default colors;

export const feedbackColors = {
  success: {
    background: supportColors.peppermint,
    border: supportColors.pineGlade,
    heading: colors.limade,
    icon: colors.limade,
  },
  info: {
    background: supportColors.catskillWhite,
    border: supportColors.aquaIsland,
    heading: supportColors.jellyBean,
    icon: supportColors.jellyBean,
  },
  warning: {
    background: supportColors.pearlLusta,
    border: supportColors.sandwisp,
    heading: supportColors.pottersClay,
    icon: supportColors.pottersClay,
  },
  danger: {
    background: supportColors.potPourri,
    border: '#444',
    heading: colors.guardsmanRed,
    icon: colors.guardsmanRed,
  },
};

export const baseFontColor = colors.tundora;
